export enum BankAccountType {
    Current, Savings,
    SAVINGS = 'SAVINGS', CURRENT = 'CURRENT' // 'SAVINGS' & 'CURRENT' is just to support the user invitations only. Do not use for other purposes
}

export class BankAccount {
    readonly name: string;
    readonly branch: string;
    readonly city: string;
    readonly ifsc: string;
    readonly accountNumber: string;
    readonly accountType: BankAccountType;
    readonly accountHolderName: string;

    constructor()
    constructor(name: string, branch: string, city: string, ifsc: string, accountNumber?: string, accountType?: BankAccountType, accountHolderName?: string)
    constructor(name?: string, branch?: string, city?: string, ifsc?: string, accountNumber?: string, accountType?: BankAccountType, accountHolderName?: string) {
        this.name = name;
        this.branch = branch;
        this.city = city;
        this.ifsc = ifsc;
        this.accountNumber = accountNumber;
        this.accountType = accountType;
        this.accountHolderName = accountHolderName;
    }
}

export class Bank {
    readonly name: string;
    readonly branch: string;
    readonly city: string;
    readonly ifsc: string;

    constructor()
    constructor(name: string, branch: string, city: string, ifsc: string)
    constructor(name?: string, branch?: string, city?: string, ifsc?: string) {
        this.name = name;
        this.branch = branch;
        this.city = city;
        this.ifsc = ifsc;
    }
}
